import React from 'react';

const SelfExclusion = () => {
  return <div>SelfExclusion</div>;
};

export default SelfExclusion;
